import React from "react";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <>
      {/* 🔥 SEO META TAGS */}
      <Helmet>
        <title>Privacy Policy | LushDesire.in – Secure & Discreet Shopping</title>

        <meta
          name="description"
          content="Read LushDesire.in Privacy Policy to understand how we protect your personal data, ensure 100% discreet delivery, and maintain secure online shopping in India."
        />

        <meta
          name="keywords"
          content="LushDesire privacy policy, sex toys privacy India, discreet delivery policy, adult store privacy India, data protection LushDesire"
        />

        <link rel="canonical" href="https://lushdesire.in/privacy-policy" />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔥 PAGE CONTENT */}
      <div
        style={{
          backgroundColor: "#FFF5F5",
          minHeight: "100vh",
          paddingTop: "120px",
          paddingBottom: "60px",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "auto",
            padding: "0 20px",
          }}
        >
          {/* ✅ MAIN H1 */}
          <h1 style={{ marginBottom: "20px", color: "#A61325" }}>
            Privacy Policy – LushDesire.in
          </h1>

          <p>
            At <strong>LushDesire</strong>, we respect your privacy and are fully
            committed to protecting your personal information. This Privacy
            Policy explains how we collect, use, store, and safeguard your data
            when you shop for personal wellness products on our website.
          </p>

          {/* ✅ H2 */}
          <h2>Information We Collect</h2>
          <p>
            When you place an order or contact us, we may collect basic details
            such as your name, phone number, email address, shipping address,
            and order-related information. This data is collected only to
            complete your purchase and provide customer support.
          </p>

          {/* ✅ H2 */}
          <h2>How We Use Your Information</h2>
          <p>
            Your information is used strictly for order processing, secure
            delivery, payment verification, customer assistance, and service
            improvement. We do <strong>not</strong> sell, rent, or misuse your
            personal data under any circumstances.
          </p>

          {/* ✅ H2 */}
          <h2>Discreet & Secure Shopping</h2>
          <p>
            LushDesire ensures <strong>100% discreet packaging</strong>. No
            explicit product names or branding appear on parcels or billing
            statements, ensuring complete privacy for customers across India.
          </p>

          {/* ✅ H2 */}
          <h2>Data Security</h2>
          <p>
            We implement industry-standard security practices to protect your
            personal data from unauthorized access, misuse, or disclosure.
            Only authorized personnel can access customer information.
          </p>

          {/* ✅ H2 */}
          <h2>Third-Party Sharing</h2>
          <p>
            Your data is never shared with third parties except trusted logistics
            and payment partners strictly required to fulfill your order.
          </p>

          {/* ✅ H2 */}
          <h2>Your Consent</h2>
          <p>
            By using <strong>LushDesire.in</strong>, you consent to our Privacy
            Policy and agree to the collection and use of information as
            described above.
          </p>

          {/* ✅ H2 */}
          <h2>Policy Updates</h2>
          <p>
            This Privacy Policy may be updated from time to time. Any changes
            will be reflected on this page with immediate effect.
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
